// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"cd149997","112":"cc2e8fd7","381":"8ce4b2d3","453":"5f90298c","461":"421d6dc9","526":"1c2600d7","694":"5672660f","718":"3d23ff1b","743":"8c059cc8","885":"1eca27bc","900":"5c1168d6","931":"ac6d7236"}[chunkId] + ".chunk.js";
};